import { render, staticRenderFns } from "./PreloaderComponent.vue?vue&type=template&id=a506ac02&"
import script from "./PreloaderComponent.vue?vue&type=script&lang=js&"
export * from "./PreloaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports